import { render } from "./SectionBalance.vue?vue&type=template&id=19a90b56&scoped=true"
import script from "./SectionBalance.vue?vue&type=script&lang=js"
export * from "./SectionBalance.vue?vue&type=script&lang=js"

import "./SectionBalance.vue?vue&type=style&index=0&id=19a90b56&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19a90b56"]])

export default __exports__